// tslint:disable-next-line function-name export-name
export function $$(
    query: string,
    container: HTMLElement | Document = document,
): HTMLElement[] {
    const list: NodeList = container.querySelectorAll(query);

    return [].slice.call(list);
}
